import Vue from 'vue'

const requireAll = requireContext => requireContext.keys().map(requireContext)
let req = require.context('./icons', false, /\.svg$/)
let iconMap = requireAll(req)
req = require.context('./icons/weather', false, /\.svg$/)
iconMap = iconMap.concat(requireAll(req))
// Vue.prototype.$IconSvg = iconMap.map(e => e.default.id.slice(3))
